import { useCallback } from 'react';
import { download as swDownload } from '@/lib/download';
import { ToastVariant } from '@/components/ui/toast';
import { useToast } from '@/components/ui/use-toast';
import { useTranslations } from 'next-intl';

export const useDownload = ({ title, description }: { title: string; description: string }) => {
  const { toast } = useToast();
  const tErrors = useTranslations('errors');
  const tCommon = useTranslations('common');

  return useCallback(
    async (url: string, name: string) => {
      try {
        await swDownload(url, name);
        toast({ title, description });
      } catch {
        toast({
          variant: ToastVariant.DESTRUCTIVE,
          title: tCommon('error'),
          description: tErrors('toastDefaultDescription'),
        });
      }
    },
    [toast, tCommon, tErrors, title, description],
  );
};
